const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgPinOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8L5 12.1667C5 12.3877 5.11706 12.5996 5.32544 12.7559C5.53381 12.9122 5.81643 13 6.11111 13H10M13 13H13.8889C14.1836 13 14.4662 12.9122 14.6746 12.7559C14.8829 12.5996 15 12.3877 15 12.1667L12 8V4.66667C12 4.22464 11.9532 3.80072 11.8698 3.48816C11.7865 3.1756 11.6734 3 11.5556 3L8.44444 3C8.32657 3 8.21352 3.1756 8.13017 3.48816C8.04683 3.80072 8 4.22464 8 4.66667M10 17.6666V15M1 1L19 19",
    stroke: "#0099FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOff);
export default __webpack_public_path__ + "static/media/pin-off.216b4489ef30c8e58063e00a23148ce7.svg";
export { ForwardRef as ReactComponent };